export default {
  'Faroe Islands': 'fo',
  'United States Minor Outlying Islands': 'um',
  'United States of America': 'us',
  Japan: 'jp',
  Seychelles: 'sc',
  India: 'in',
  France: 'fr',
  'Federated States of Micronesia': 'fm',
  Micronesia: 'fm',
  China: 'cn',
  'Hong Kong': 'cn',
  'Serranilla Bank': 'sw',
  'Scarborough Reef': 'sh',
  Brazil: 'br',
  Ecuador: 'ec',
  Australia: 'au',
  Kiribati: 'ki',
  Philippines: 'ph',
  Mexico: 'mx',
  Spain: 'es',
  'Bajo Nuevo Bank (Petrel Is.)': 'bu',
  Maldives: 'mv',
  'Spratly Islands': 'sp',
  'United Kingdom': 'gb',
  Greece: 'gr',
  'American Samoa': 'as',
  Denmark: 'dk',
  Greenland: 'gl',
  Guam: 'gu',
  'Northern Mariana Islands': 'mp',
  'Puerto Rico': 'pr',
  'United States Virgin Islands': 'vi',
  'British Virgin Islands': 'vi',
  Canada: 'ca',
  'Sao Tome and Principe': 'st',
  'United Republic of Tanzania': 'tz',
  Tanzania: 'tz',
  'Cape Verde': 'cv',
  Dominica: 'dm',
  Netherlands: 'nl',
  Jamaica: 'jm',
  Samoa: 'ws',
  Oman: 'om',
  'Saint Vincent and the Grenadines': 'vc',
  Turkey: 'tr',
  Bangladesh: 'bd',
  'Solomon Islands': 'sb',
  'Saint Lucia': 'lc',
  Nauru: 'nr',
  Norway: 'no',
  'Saint Kitts and Nevis': 'kn',
  Bahrain: 'bh',
  Tonga: 'to',
  Finland: 'fi',
  Indonesia: 'id',
  Mauritius: 'mu',
  Sweden: 'se',
  'Trinidad and Tobago': 'tt',
  Malaysia: 'my',
  'The Bahamas': 'bs',
  Bahamas: 'bs',
  Panama: 'pa',
  Palau: 'pw',
  Tuvalu: 'tv',
  'Marshall Islands': 'mh',
  Chile: 'cl',
  Thailand: 'th',
  Grenada: 'gd',
  Estonia: 'ee',
  'Antigua and Barbuda': 'ag',
  Taiwan: 'tw',
  Barbados: 'bb',
  Italy: 'it',
  Malta: 'mt',
  'Papua New Guinea': 'pg',
  Germany: 'de',
  Vanuatu: 'vu',
  Singapore: 'sg',
  Cyprus: 'cy',
  Comoros: 'km',
  Fiji: 'fj',
  Russia: 'ru',
  'Russian Federation': 'ru',
  Vatican: 'va',
  'San Marino': 'sm',
  Kazakhstan: 'kz',
  Azerbaijan: 'az',
  Armenia: 'am',
  Tajikistan: 'tj',
  Lesotho: 'ls',
  Uzbekistan: 'uz',
  Portugal: 'pt',
  Morocco: 'ma',
  Colombia: 'co',
  'East Timor': 'tl',
  Cambodia: 'kh',
  Argentina: 'ar',
  'Saudi Arabia': 'sa',
  Pakistan: 'pk',
  Yemen: 'ye',
  'United Arab Emirates': 'ae',
  Kenya: 'ke',
  Peru: 'pe',
  'Dominican Republic': 'do',
  Haiti: 'ht',
  Angola: 'ao',
  Vietnam: 'vn',
  Mozambique: 'mz',
  'Costa Rica': 'cr',
  Iran: 'ir',
  'El Salvador': 'sv',
  'Sierra Leone': 'sl',
  'Guinea Bissau': 'gw',
  Croatia: 'hr',
  Belize: 'bz',
  'South Africa': 'za',
  'Democratic Republic of the Congo': 'cd',
  Congo: 'cd',
  'DR Congo': 'cd',
  Kuwait: 'kw',
  Ireland: 'ie',
  'North Korea': 'kp',
  'South Korea': 'kr',
  Guyana: 'gy',
  Honduras: 'hn',
  Myanmar: 'mm',
  Gabon: 'ga',
  'Equatorial Guinea': 'gq',
  Nicaragua: 'ni',
  Uganda: 'ug',
  Malawi: 'mw',
  Somaliland: 'sx',
  Turkmenistan: 'tm',
  Zambia: 'zm',
  'Northern Cyprus': 'nc',
  Mauritania: 'mr',
  Algeria: 'dz',
  Lithuania: 'lt',
  Ethiopia: 'et',
  Sudan: 'sd',
  Eritrea: 'er',
  Ghana: 'gh',
  Slovenia: 'si',
  Guatemala: 'gt',
  'Bosnia and Herzegovina': 'ba',
  Jordan: 'jo',
  Syria: 'sy',
  Monaco: 'mc',
  Albania: 'al',
  Uruguay: 'uy',
  'Cyprus No Mans Area': 'cnm',
  Mongolia: 'mn',
  Rwanda: 'rw',
  Somalia: 'so',
  Bolivia: 'bo',
  Cameroon: 'cm',
  'Republic of Congo': 'cg',
  'Western Sahara': 'eh',
  'Republic of Serbia': 'rs',
  Serbia: 'rs',
  Montenegro: 'me',
  Benin: 'bj',
  Nigeria: 'ng',
  Togo: 'tg',
  Laos: 'la',
  Afghanistan: 'af',
  Ukraine: 'ua',
  Slovakia: 'sk',
  'Siachen Glacier': 'jk',
  Bulgaria: 'bg',
  Qatar: 'qa',
  Liechtenstein: 'li',
  Austria: 'at',
  Swaziland: 'sz',
  Hungary: 'hu',
  Romania: 'ro',
  Luxembourg: 'lu',
  Andorra: 'ad',
  'Ivory Coast': 'ci',
  Liberia: 'lr',
  Brunei: 'bn',
  Belgium: 'be',
  Iraq: 'iq',
  Georgia: 'ge',
  Gambia: 'gm',
  Switzerland: 'ch',
  Chad: 'td',
  Kosovo: 'kv',
  Lebanon: 'lb',
  Djibouti: 'dj',
  Burundi: 'bi',
  Suriname: 'sr',
  Israel: 'il',
  Mali: 'ml',
  Senegal: 'sn',
  Guinea: 'gn',
  Zimbabwe: 'zw',
  Poland: 'pl',
  Macedonia: 'mk',
  'North Macedonia': 'mk',
  Paraguay: 'py',
  Belarus: 'by',
  Latvia: 'lv',
  'Czech Republic': 'cz',
  'Burkina Faso': 'bf',
  Namibia: 'na',
  Niger: 'ne',
  Libya: 'ly',
  Tunisia: 'tn',
  Bhutan: 'bt',
  Moldova: 'md',
  'South Sudan': 'ss',
  'Central African Republic': 'cf',
  'New Zealand': 'nz',
  Cuba: 'cu',
  Venezuela: 've',
  Madagascar: 'mg',
  Iceland: 'is',
  Egypt: 'eg',
  'Sri Lanka': 'lk',
  Botswana: 'bw',
  Kyrgyzstan: 'kg',
  Nepal: 'np',
};
